module.exports = {
  __init__: [ 'defaultRenderer' ],
  defaultRenderer: [ 'type', require(39) ],
  styles: [ 'type', require(40) ]
};
